var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgExclamationCircle = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 14",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.00016,
    cy: 7.00016,
    r: 6.41813,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.80033 4.19906C7.80033 3.75689 7.44188 3.39844 6.99971 3.39844C6.55753 3.39844 6.19908 3.75689 6.19908 4.19906V6.82406C6.19908 7.26624 6.55753 7.62469 6.99971 7.62469C7.44188 7.62469 7.80033 7.26624 7.80033 6.82406V4.19906ZM6.99971 8.83656C6.41981 8.83656 5.94971 9.30666 5.94971 9.88656C5.94971 10.4665 6.41981 10.9366 6.99971 10.9366H7.00846C7.58836 10.9366 8.05846 10.4665 8.05846 9.88656C8.05846 9.30666 7.58836 8.83656 7.00846 8.83656H6.99971Z",
    fill: "#5B3D01"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgExclamationCircle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ExclamationCircle.05fcdf8a806b5d115743785f91fefca6.svg";